<template>
  <publicExport :exportTypeList="exportTypeList"></publicExport>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import publicExport from "@/components/common/publicExport";
import {setConfigCharacters} from "@/utils/common";

export default {
  name: "exportTask",
  data() {
    return {
      exportTypeList: [
        {value: 'ymsProductInfoExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002924')},
        {value: 'ymsPickupOrderExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002648')},
        {value: 'ymsContainerStatusChangeOrderExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002925')},
        {value: 'ymsProductInventoryExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002926')},
        {value: 'ymsContainerStatusShelvesOrderExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002651')},
        {value: 'ymsPickupOrderListExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002927')},
        {value: 'ymsPackageInfoExport', name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001887')}`},
        {value: 'ymsDataCenterExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002928')},
        {value: 'ymsQuestionnaireStatisticsExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002929')},
        {value: 'ymsSubsidyAuditListExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002930')},
        {value: 'supplierPackageStockExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001739')},
        {value: 'ymsDistributorMerchantRechargeRecordExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002931')},
        {value: 'ymsSupplierBillExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002932')},
        {value: 'ymsSupplierBillDetailExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002933')},
        {value: 'ymsPickingOrderSortingExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002652')},
        {value: 'ymsPickingOrderPackingExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002654')},
        {value: 'supplierPackageInfoExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002934')},
        {value: 'ymsProductAttributeTemplateExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002935')},
        {value: 'ymsDistributorBillExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000494')},
        {value: 'LogisticsBillExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002936')},
        {value: 'ymsWarehouseBillExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002937')},
        {value: 'ymsProductInventoryDetailExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002938')},
        {value: 'ymsCoreBillExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000495')},
      ]
    };
  },
  components: {
    publicExport
  }
};
</script>

<style scoped>

</style>
